import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from 'app/main/shared/notification.service';
import { AuthenticationService } from 'app/services/authentication.service';
import { encryptStorage } from 'environments/environment';
import { clientID } from 'environments/environment.prod';
import { Common } from './../../../utility/common';
// import { NgRecaptcha3Service } from "ng-recaptcha3";
import { environment } from  'environments/environment';

@Component({
  selector: 'ngx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: any;
  loading = false;
  submitted = false;
  returnUrl: string;
  boolStoredRememberValue: boolean;
  previousUrl:any;
  public clientid = clientID;
  isChangeIcon:boolean=true;
  inputType:string="password";
  iconClass:string="fa fa-eye-slash";
  public environment = environment;

  constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private notifyService: NotificationService,
        // private recaptcha3: NgRecaptcha3Service,
  ) { }
 
  toggleIcon(){
 this.isChangeIcon=!this.isChangeIcon;
       if(this.isChangeIcon){
        this.inputType="password";
        this.iconClass="fa fa-eye-slash";
       }else{
        this.inputType="text";
        this.iconClass="fa fa-eye";
       }
  }
  configerLoginDetails(){
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      terminal: ['', Validators.required],
      clientId: ['']
      // recaptchaToken: ['']
  });
  }

  get f() { return this.loginForm.controls; }

  
  async onSubmit() {
     
    if (this.loginForm.value.username != null || this.loginForm.value.username != ""
    || this.loginForm.value.password != null || this.loginForm.value.password != "") {
      // await this.recaptcha3.getToken().then(
      //     token => {
      //       this.loginForm.value.recaptchaToken = token;
      //       
      //     },
      //     error => {
      //       console.log(error);
      //     }
      //   );
      console.log(this.loginForm);
      }

    if (this.loginForm.value.username == null || this.loginForm.value.username == ""
      || this.loginForm.value.password == null || this.loginForm.value.password == "") {
      // this.notifyService.showWarning("Username and Password Required", "Warning");
      this.notifyService.showWarning("Username and Password Required", "Warning")
      return;
    }

    if (this.loginForm.value.password != "") {
      this.loginForm.value.isLocalStorageData = true;
      // this.loginForm.value.password = this.rsdx;
    }
    Common.showloader();
    this.loginForm.value.clientId = this.clientid;
      await this.authenticationService.login(this.loginForm.value)
      .pipe()
      .subscribe(
        res => {
          Common.hideloader();
            if(res !=null){
              const landingPage = "/auth/StartupPage";
              this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || landingPage;
            }
          if (res.systemId == "AfcsAdmin") {
        
            if(this.authenticationService.currentUserValue.menuList.filter(x=>x.link ===  this.authenticationService.currentUserValue.landingpageInfo[0].strMenuUrl).length > 0)
            // if(this.authenticationService.currentUserValue!= null && this.authenticationService.currentUserValue.landingpageInfo!=null
            //   && this.authenticationService.currentUserValue.landingpageInfo.length > 0 &&  this.authenticationService.currentUserValue.landingpageInfo[0].strMenuUrl!=null
            //   &&  this.authenticationService.currentUserValue.landingpageInfo[0].strMenuUrl!= "")
            {
              
              const landingPage = this.authenticationService.currentUserValue.landingpageInfo[0].strMenuUrl;
              //const landingPage = "/auth/StartupPage";
              this.authenticationService.landingPage = landingPage;
 
            }
            else 
            {
              if(this.authenticationService.currentUserValue.menuList.length > 0)
              {
                
                const landingPage = this.authenticationService.currentUserValue.menuList[0].link
                this.authenticationService.landingPage  = landingPage;
              }
              else 
              {
              
                //const landingPage = this.authenticationService.currentUserValue.landingpageInfo[0].strMenuUrl
                const landingPage = "/auth/StartupPage";
                this.authenticationService.landingPage = landingPage;
 

              }
            }

          } //Clientmaster
         
          Common.hideloader();
          this.router.navigate([this.returnUrl]);
       
          this.boolStoredRememberValue = (encryptStorage.getItem('isRemember') == 'true');

        }
      );
  }

  rememberCredentials(rsdx) {
    if (this.boolStoredRememberValue) {
      encryptStorage.setItem("userEmail", this.loginForm.value.username);
      encryptStorage.setItem("rsdx", rsdx);
    }
    else {
      encryptStorage.removeItem("userEmail");
      encryptStorage.removeItem("rsdx");
    }
    
  }

  ngOnInit(): void {
    Common.hideloader();
    // this.recaptcha3.init(this.environment.recaptcha.siteKey);

    var data = encryptStorage.getItem('currentUser');
    if (data != null)
    {



      if(this.authenticationService.currentUserValue.menuList.filter(x=>x.link ===  this.authenticationService.currentUserValue.landingpageInfo[0].strMenuUrl).length > 0)
      {
        const landingPage = this.authenticationService.currentUserValue.landingpageInfo[0].strMenuUrl
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || landingPage;

      }
      else 
      {
        if(this.authenticationService.currentUserValue.menuList.length > 0)
        {

          const landingPage = this.authenticationService.currentUserValue.menuList[0].link
          this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || landingPage;

        }
        else 
        {

          const landingPage = this.authenticationService.currentUserValue.landingpageInfo[0].strMenuUrl
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || landingPage;


        }

      }

      //  const landingPage= this.authenticationService.currentUserValue.landingpageInfo[0].strMenuUrl
      //  this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || landingPage;
       this.router.navigate([this.returnUrl]);
       Common.showloader();
          // Handle saving form data
          // this.myHttpService.login(this.formData).subscribe(response => {
          //
          // });
    }
    else
    {
     //   this.router.navigate(['']);
    }
    this.configerLoginDetails();
  }
  ngOnDestroy(): void {
    console.log("Destroying loop"); // ngOnDestroy is not triggering
    // this.recaptcha3.destroy();
  }
}
